(function () {
  'use strict';
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var nativeTimeline = window.CSS && CSS.supports('animation-timeline: view()') && CSS.supports('animation-range: contain');

  function init(root) {
    if (root.c03ArrivalCleanup) root.c03ArrivalCleanup();
    if (motion.matches) return;
    if (!nativeTimeline && !Element.prototype.animate) return;
    root.classList.add('is-ready');
    var animations = [];
    var frame = 0;
    var active = true;
    var observer;
    var stage = root.querySelector('.c03-arrival__stage');
    function update() {
      frame = 0;
      if (!active) return;
      var bounds = root.getBoundingClientRect();
      var distance = Math.max(1, root.offsetHeight - stage.offsetHeight);
      var progress = Math.max(0, Math.min(1, -bounds.top / distance));
      animations.forEach(function (animation) { animation.currentTime = progress * 1000; });
    }
    function schedule() { if (active && !frame) frame = requestAnimationFrame(update); }
    if (!nativeTimeline) {
      var tracks = [
        ['.c03-arrival__jamb--left', [{ transform: 'translateX(0)' }, { transform: 'translateX(-105%)' }]],
        ['.c03-arrival__jamb--right', [{ transform: 'translateX(0)' }, { transform: 'translateX(105%)' }]],
        ['.c03-arrival__room', [{ transform: 'scale(1)' }, { transform: 'scale(1.045)' }]],
        ['.c03-arrival__copy', [{ opacity: 1, transform: 'translateY(0)', offset: 0 }, { opacity: 1, transform: 'translateY(0)', offset: .08 }, { opacity: 0, transform: 'translateY(-32px)', offset: .48 }, { opacity: 0, transform: 'translateY(-32px)', offset: 1 }]],
        ['.c03-arrival__reveal', [{ opacity: 0, transform: 'translateY(18px)', offset: 0 }, { opacity: 0, transform: 'translateY(18px)', offset: .62 }, { opacity: 1, transform: 'translateY(0)', offset: .9 }, { opacity: 1, transform: 'translateY(0)', offset: 1 }]]
      ];
      tracks.forEach(function (track) {
        var animation = root.querySelector(track[0]).animate(track[1], { duration: 1000, fill: 'both', easing: 'linear' });
        animation.pause(); animations.push(animation);
      });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) { active = entries[0].isIntersecting; if (active) schedule(); });
        observer.observe(root);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
    }
    root.c03ArrivalCleanup = function () {
      cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      animations.forEach(function (animation) { animation.cancel(); });
      root.classList.remove('is-ready');
      delete root.c03ArrivalCleanup;
    };
  }
  function initAll() { document.querySelectorAll('[data-c03-arrival]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-c03-arrival]').forEach(function (root) { if (root.c03ArrivalCleanup) root.c03ArrivalCleanup(); });
  });
  if (motion.addEventListener) motion.addEventListener('change', initAll);
  else motion.addListener(initAll);
})();
